import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getScanDatasetIdFromLocation = createSelector([
  getLocationMetadata
], (locationMetadata) => locationMetadata.scanDatasetId || null);

export default getScanDatasetIdFromLocation;